import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getAccessToken } from '@/utils/auth'
import { isRelogin } from '@/utils/request'
import {toCamelCase} from "@/utils";
import loadView from '@/store/modules/permission'
import Layout from '@/layout'

NProgress.configure({ showSpinner: false })

// 增加三方登陆 update by 芋艿
const whiteList = ['/login', '/social-login',  '/auth-redirect', '/bind', '/register', '/oauthLogin/gitee']

router.beforeEach((to, from, next) => {
  console.log('路由信息', to)
  NProgress.start()
  if (getAccessToken()) {
    // to.meta.title && store.dispatch('settings/setTitle', to.meta.title)
    /* has token*/
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done()
    } else {
      if (store.getters.roles.length === 0) {
        isRelogin.show = true
        // 获取字典数据 add by 芋艿
        // store.dispatch('dict/loadDictDatas')
        // 判断当前用户是否已拉取完 user_info 信息
        store.dispatch('GetInfo').then(userInfo => {
          isRelogin.show = false
          // 触发 GenerateRoutes 事件时，将 menus 菜单树传递进去
          store.dispatch('GenerateRoutes', userInfo.menus).then(accessRoutes => {
            for (const accessRoute of accessRoutes) {
              router.addRoute(accessRoute);
            }
            next({ ...to, replace: true }) // hack方法 确保addRoutes已完成
          })
        }).catch(err => {
          store.dispatch('LogOut').then(() => {
            Message.error(err)
            next({ path: '/' })
          })
        })
      } else {
        next()
      }
    }
  } else {
    // 没有token
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      next()
    } else {
      const redirect = encodeURIComponent(to.fullPath) // 编码 URI，保证参数跳转回去后，可以继续带上
      next(`/login?redirect=${redirect}`) // 否则全部重定向到登录页
      NProgress.done()
    }
  }
})

router.afterEach((to, from) => {
  NProgress.done()
  // 添加多页签标签
  if (to.name && !to.meta.noCache) {
    store.dispatch('tagsView/addView', to)
  } else if (to.name && to.meta.noCache) {
    // noCache 页面仍然加入已访问列表但不缓存
    store.dispatch('tagsView/addVisitedView', to)
  }
})



// WEBPACK FOOTER //
// ./src/permission.js